import Label from '~/src/atoms/Label';
import ColorShadesIcon from '../../../public/bb2assets/images/svg/color_shades.svg';
import RightArrowIcon from '../../../public/bb2assets/images/svg/right_arrow.svg';
import tw from 'twin.macro';
import React from 'react';
import Link from '~/src/atoms/Link';
import useSelectedPack from './useSelectedPack';

const CosmeticSelector = ({ showCosmetics = true, ...rest }) => {
  const { additionalAttributes = {}, absoluteUrl = '' } = useSelectedPack();
  const isParentChild = additionalAttributes?.info?.find((value) => value?.type === 'parent_child_variant_type');
  if (!isParentChild || !showCosmetics)
    return (
      <div className="w-full py-3 border border-transparent">
        <div className="py-0.5"></div>
      </div>
    );
  return (
    <Link href={absoluteUrl}>
      <div
        className="flex items-center justify-between lg:h-7 xl:h-7.5 box-border bg-white border border-solid border-silverSurfer-400 hover:border-darkOnyx-400 rounded-2xs font-regular lg:text-sm xl:text-md leading-none text-darkOnyx-400"
        {...rest}
      >
        <Label css={tw`truncate flex items-center`}>
          <ColorShadesIcon className="ml-2" />
          <Label css={tw`ml-1.5 mt-px`}>{isParentChild?.label}</Label>
        </Label>
        <RightArrowIcon className="mr-1.5" />
      </div>
    </Link>
  );
};

export default CosmeticSelector;
